export default "__VITE_ASSET__BpiOKDoz__"